// Aspect ratios for the detection engine. The table itself lives in
// `domain/document-format` so the guide overlay, the shimmer picker and the
// detector can never drift apart; this module only adds the detection-specific
// typing and the discovery classifier.
import { SHAPE_ASPECT_RATIOS } from '../../../../../domain/document-format';

export const ASPECT_RATIOS: Record<
  'id-card' | 'passport' | 'greenbook',
  number
> = SHAPE_ASPECT_RATIOS;

export type AspectKey = keyof typeof ASPECT_RATIOS;
export type DiscoveryVote = 'id-card' | 'passport';

export const isAspectKey = (v: unknown): v is AspectKey =>
  typeof v === 'string' &&
  Object.prototype.hasOwnProperty.call(ASPECT_RATIOS, v);

const ASPECT_RATIO_MIDPOINT =
  (ASPECT_RATIOS['id-card'] + ASPECT_RATIOS.passport) / 2;

export const classifyDiscoveryAspect = (
  normalizedAspect: number,
): DiscoveryVote =>
  normalizedAspect >= ASPECT_RATIO_MIDPOINT ? 'id-card' : 'passport';
